import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ModalController } from '@ionic/angular';
import {
  BudgetItem,
  BudgetItemSummary,
  BudgetMacroItem,
  CashFundSplitRow,
  CostCenterSummary,
  Identity,
  ProjectArticle,
  ProjectSubtaskSummary,
} from '@libs/core/api';
import { FormBuilder, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'front-end-fund-cash-split-row-modal',
  templateUrl: './fund-cash-split-row-modal.component.html',
  styleUrls: ['./fund-cash-split-row-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FundCashSplitRowModalComponent implements OnInit {
  @Input() project!: CostCenterSummary;
  @Input() identity!: Identity;
  @Input() maxAmount!: number;

  budgetProjectTasks: BudgetMacroItem[] = [];
  allowedSubtasks: ProjectSubtaskSummary[] = [];

  form = this.fb.group({
    budgetItem: new FormControl<BudgetItemSummary | null>(null, {
      validators: [Validators.required],
    }),
    article: new FormControl<ProjectArticle | null>(null, {
      validators: [Validators.required],
    }),
    amount: new FormControl<number | null>(null, {
      validators: [Validators.required, Validators.min(0.01)],
    }),
  });

  constructor(
    private readonly modalController: ModalController,
    private readonly fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.budgetProjectTasks =
      this.identity.companies?.flatMap(
        (c) => c.costCenters?.flatMap((cc) => cc.macroItems ?? []) ?? []
      ) ?? [];

    this.allowedSubtasks =
      this.project.subtasks?.filter(
        (subtask) => (subtask.buyer ?? false) || (subtask.superBuyer ?? false)
      ) ?? [];

    this.form.controls.amount.addValidators(Validators.max(this.maxAmount));
    this.form.controls.amount.updateValueAndValidity();
  }

  apply(): void {
    if (!this.form.valid) return;

    const budgetItem = this.form.value.budgetItem as BudgetItem;
    const article = this.form.value.article as ProjectArticle;
    const amount = this.form.value.amount as number;

    const subtask: ProjectSubtaskSummary = {
      id: budgetItem.id,
      name: budgetItem.name,
      code: budgetItem.code,
      taskName: budgetItem.macroItem?.name,
    };

    const splitRow: CashFundSplitRow = {
      subtask,
      article,
      amount,
    };

    this.modalController.dismiss(splitRow, 'apply');
  }

  close(): void {
    this.modalController.dismiss(null, 'cancel');
  }
}
